import React from 'react';

function mirror(o) {
  return o;
}

export default function mapSelf(children) {
  // return ReactFragment
  return React.Children.map(children, mirror);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-util/es/Children/mapSelf.js
// module id = 358
// module chunks = 0